import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Form, Input, message, notification, Popconfirm } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function Country() {
    const auth = useAuthUser()
    const [countryForm] = Form.useForm();
    const [state, setState] = useState({
        gvCountryLoading: false,
        gvCountry: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getCountryPageLoad()
        // eslint-disable-next-line
    }, [])
    const getCountryPageLoad = () => {
        handleSetState({ gvCountryLoading: true })
        axios.get(`/Country/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvCountryLoading: false,
                    gvCountry: resData.Data.gvCountry
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishCountry = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/Country/Create`, {
                countryCode: formData.countryCode,
                countryName: formData.countryName,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getCountryPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/Country/Update`, {
                countryId: formData.countryId,
                countryName: formData.countryName,
                countryCode: formData.countryCode,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getCountryPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeleteCountry = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/Country/Delete`, {
            countryId: countryForm.getFieldValue("countryId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getCountryPageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Country" },
        ]}>
            <Container>
                <PageHeader title="Country" subtitle="List of country details.">
                    {isAllowToManage() && <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            countryForm.resetFields();
                            handleSetState({
                                formOpen: true,
                                formType: "Add",
                            })
                        }}
                    >
                        New Country
                    </Button>}
                </PageHeader>
                <AgoraTable
                    loading={state.gvCountryLoading}
                    dataSource={state.gvCountry}
                    rowKey="countryId"
                    columns={[
                        {
                            title: 'Country Name',
                            dataIndex: 'countryName',
                            key: 'countryName',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div>{text || "-"}</div>
                                <div className="i-x-right">
                                    {isAllowToManage() && <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                        onClick={() => {
                                            countryForm.setFieldsValue({
                                                countryId: record.countryId,
                                                countryCode: record.countryCode,
                                                countryName: record.countryName,
                                            });
                                            handleSetState({
                                                formOpen: true,
                                                formType: "Edit",
                                            })
                                        }}
                                    ><EditOutlined /> Edit</Button>}
                                </div>
                            </div>,
                        },
                        {
                            title: 'Country Code',
                            dataIndex: 'countryCode',
                            key: 'countryCode',
                            dataType: "text",
                            render: (text) => text || "-",
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Country`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => countryForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    countryForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={countryForm}
                        name="country-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishCountry}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="countryId" ></Form.Item>
                        <Form.Item
                            label="Country Name"
                            name="countryName"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter country name!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Singapore' />
                        </Form.Item>
                        <Form.Item
                            label="Country Code"
                            name="countryCode"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter country code!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., SG' />
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete country"
                                description="Are you sure to delete this country?"
                                onConfirm={handleOnDeleteCountry}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Country</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default Country